import { IonButtons, IonCol, IonContent, IonFooter, IonGrid
  , IonHeader, IonItem, IonLabel, IonMenuButton, IonDatetime, IonFab, IonFabButton
  , IonPage, IonRow, IonTitle, IonToolbar ,IonCard, IonBadge, IonList
  , IonModal, IonButton, IonText, IonSpinner, IonIcon, IonAlert, IonBackButton} from '@ionic/react';
  import React, { useEffect, useState, useRef } from 'react';
  import { add, imageOutline, chevronBack, chevronForward, logInOutline, logOutOutline, calendarOutline, 
    personCircleOutline, timeOutline, clipboardOutline, locationOutline } from 'ionicons/icons';
import { useParams } from 'react-router';
import './Job.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import ServerService from '../../../services/Server';
import MapContainer, { MapContainerRef } from '../../../components/MapContainer';
import { useIonRouter } from '@ionic/react';
import { Environment } from "../../../data/Environment";

const Con: React.FC = () => {
const router = useIonRouter();

const [showCheckIn, setShowCheckIn] = useState<boolean>(false);
const [showCheckOut, setShowCheckOut] = useState<boolean>(false);
const [showConfirmAlert, setShowConfirmAlert] = useState(false);
const [isLoadAddress, setIsLoadAddress] = useState<boolean>(false);
const [showFailMsg, setShowFailMsg] = useState(false);
const [showHistory, setShowHistory] = useState(false);

const [checkInTime, setCheckInTime] = useState<string>("");
const [checkOutTime, setCheckOutTime] = useState<string>("");

const [sprintText, setSprintText] = useState<string>("กำลังระบุพิกัดที่แม่นยำ...");

const [checkTitle, setCheckTitle] = useState<string>("");
const [checkBtnText, setCheckBtnText] = useState<string>("");
const [useCheckType, setUseCheckType] = useState<string>("");

const [myAddress, setMyAddress] = useState<string>("");
const [latitude, setLatitude] = useState<number>();
const [longitude, setLongitude] = useState<number>();
const [time, setTime] = useState<string>("");
const [jobId, setJobId] = useState<string>("");
const [urlProfile, setUrlProfile] = useState<any>(null);

const [mapKey, setMapKey] = useState(null);

const [showBeginButton, setShowBeginButton] = useState<boolean>(false);
const [showEndButton, setShowEndButton] = useState<boolean>(false);


const mapRef = useRef<MapContainerRef>(null);

const server = new ServerService();
const state = server.state;
const data = {username:state.username, password:state.password}

//const [details, setDetails] = useState<any>();

const { id } = useParams<{ id: string }>();
const { dtlid } = useParams<{ dtlid: string }>();

const [details, setDetails] = useState({
  name : '',
  flag5 : '',
  flag6 : '',
  flag7 : '',
  flag8 : '',
  flag9 : '',
  activity_id : '',
  work_date_text : '',
  start_time_text : '',
  end_time_text : '',
  job_status : '',
  job_id : ''
});

const fetchDetails = function() {
  const data = { 
    alf_ticket : state.ticket,
    id : id,
    dtlid : dtlid
  }
  fetch(server.getFullUrl("activity/mb/getActivityDtl", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      if(result.status=='E'){
        return false;
      }else{
        setDetails(result.data);
      }
    },
    (error) => {

    }
 ).catch(e => {

 })
).catch(e => {
}) 
}

const fetchProfile = function() {
  const data = { 
    alf_ticket : state.ticket
  }
  fetch(server.getFullUrl("bams/getProfile", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      if(result.status=='E'){
        return false;
      }else{
       // setProfile(result.data);
        setMapKey(result.mapKey);
      }
    },
    (error) => {

    }
 ).catch(e => {

 })
).catch(e => {
}) 
}

useEffect(() => {
  fetchDetails();
  fetchProfile();
}, []);

console.log('job id :: ' + id);
console.log('job dtlid :: ' + dtlid);

const handleOpenCheckInOut = (checkType : string) => {
  setCheckTitle("");
  setCheckBtnText("");
  setUseCheckType(checkType);
  console.log(checkType);
  if(checkType=='in'){
    setCheckTitle('ปฎิบัติงาน');
    setCheckBtnText('ตกลง');
  }else if(checkType=='out'){
    setCheckTitle('จบการปฎิบัติงาน');
    setCheckBtnText('ตกลง');
  }
 
  setShowCheckIn(true);
};

const handleModalDidPresent = () => {
  console.log("Modal presented, waiting for map...");
  setIsLoadAddress(true);
  
  setTimeout(() => {
    if (mapRef.current) {
      console.log("Triggering address fetch automatically...");
      setTimeout(() => {
        mapRef.current.triggerGetAddress();
      }, 2000);
    
     // setIsLoadAddress(false);  
     
    } else {
      console.log("MapRef is still null, trying again...");
     
      setTimeout(() => mapRef.current?.triggerGetAddress(), 2000);
      if(latitude == 0.0 || latitude == undefined){
        setSprintText("ไม่สามารถระบุพิกัดได้กรุณาตรวจสอบ GPS");
      }else{
       // setIsLoadAddress(false);  
      }
     
     
    }
  }, 3000); 
};

useEffect(() => {
  
  setIsLoadAddress(false);  
  
}, [latitude, longitude, myAddress]);
const handleAddressFromMap = (address: string) => {
  setMyAddress(address); 
  console.log("ไฟล์แม่ได้รับข้อมูลแล้ว:", address);
};

const handleLatitude = (lat: number) => {
  setLatitude(lat); 
  console.log("Latitude:", lat);
};
const handleLongitude = (lon: number) => {
  setLongitude(lon); 
  console.log("Longitude:", lon);
};

const handleCheckInClick = () => {
  setShowConfirmAlert(true); 
};

const handleFinalConfirm = () => {
  console.log("Checking mapRef.current:", mapRef.current);
  
  if (mapRef.current) {
    mapRef.current.triggerGetAddress();
    //sendCheckInOut();
  } else {
   
    setTimeout(() => {
      if (mapRef.current) {
        mapRef.current.triggerGetAddress();
       // sendCheckInOut();
      } else {
        console.log("Ref is still null even after delay");
      }
    }, 100);
  }

};

const sendCheckInOut = () =>{
  if(latitude == 0.0){
  //if(true){ //test
    setShowFailMsg(true);
    return false;
  }else{
   
    if(useCheckType == 'in'){
      sendCheckIn();
    }else if(useCheckType == 'out'){
      sendCheckOut();
    }

    setShowCheckIn(false);
  }
  
}

const sendCheckIn = function() {
  //2025-10-08 16:38:33;RC39+JX ตำบล มหาสวัสดิ์ อำเภอบางกรวย นนทบุรี ประเทศไทย|(13.804097544594082, 100.41999436738122)
  const data = {  
    alf_ticket : state.ticket,
    myAddress : myAddress,
    latitude : latitude ,
    longitude : longitude,
    module : ''
  }
  fetch(server.getFullUrl("bams/activityCheckIn", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      if(!result.success){
        return false;
      }else{
        setJobId(result.jobId);
        //fetchCheckToDay();
      }
    },
    (error) => {

    }
 ).catch(e => {

 })
).catch(e => {
}) 
}

const sendCheckOut = function() {
  //2025-10-08 16:38:33;RC39+JX ตำบล มหาสวัสดิ์ อำเภอบางกรวย นนทบุรี ประเทศไทย|(13.804097544594082, 100.41999436738122)
  const data = { 
    alf_ticket : state.ticket,
    jobId : jobId, 
    myAddress : myAddress,
    latitude : latitude ,
    longitude : longitude,
    module : ''
  }
  fetch(server.getFullUrl("bams/activityCheckOut", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      if(!result.success){
        return false;
      }else{
        //fetchCheckToDay();
      }
    },
    (error) => {

    }
 ).catch(e => {

 })
).catch(e => {
}) 
}
const handleCloseMap = () => {
  console.log('handleCloseMap');
  setShowCheckIn(false);
  setLatitude(null);
  setLongitude(null);
  setMyAddress(null);
};

 return (
 
  <IonPage>
     
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonBackButton defaultHref="/home" text="" />
          </IonButtons>
          <IonTitle style={{ fontSize: '0.9rem' }}>
            เตรียมปฏิบัติงาน
          </IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent color="light">
        <div className="detail-container">
        
          {/*
          <div className="header-section">
            <div className="image-placeholder">
              <IonIcon icon={imageOutline} color="primary" />
            </div>
            <h2 className="location-name">{details.name}</h2>
          </div>
          */}
        
          <IonList lines="full" className="info-list">
            <IonItem className='ion-job-item'>
            <IonLabel className='ion-job-label' color="dark" style={{ flex: 'none', width: '100px' }}>สถานที่ / สาขา</IonLabel>
            <IonText color="primary" className="ion-text-right ion-job-text" style={{ 
              width: '100%', 
              paddingLeft: '10px',
              fontSize: '0.9rem',
              wordBreak: 'break-word' 
            }}>
              {details.flag5} {details.flag6} {details.flag7} {details.flag8} {details.flag9}
            </IonText>
            </IonItem>
            
            <IonItem className='ion-job-item'>
              <IonLabel className='ion-job-label' color="dark" style={{ flex: 'none', width: '100px' }}>เวลาเริ่มต้น</IonLabel>
              <IonText color="primary" className="ion-text-right ion-job-text" style={{ 
              width: '100%', 
              paddingLeft: '10px',
              fontSize: '0.9rem',
              wordBreak: 'break-word'
            }}>
                {details.work_date_text} {details.start_time_text}</IonText>
            </IonItem>
            <IonItem className='ion-job-item'>
              <IonLabel className='ion-job-label' color="dark">เวลาสิ้นสุด</IonLabel>
              <IonText color="primary" className="ion-text-right ion-job-text" style={{ 
              width: '100%', 
              paddingLeft: '10px',
              fontSize: '0.9rem',
              wordBreak: 'break-word' 
            }}>
                {details.work_date_text} {details.end_time_text}</IonText>
            </IonItem>
           
          </IonList>
        </div>
      </IonContent>

     
      <IonFooter className="ion-no-border">
        <IonToolbar>
          <IonRow className="button-row">
            <IonCol>
              <IonButton expand="block"  className="action-btn btn-blue"
              onClick={() => handleOpenCheckInOut('in')} >
                ปฏิบัติงาน
              </IonButton>
            </IonCol>
            <IonCol>
              <IonButton expand="block"  className="action-btn btn-orange"
              onClick={() => handleOpenCheckInOut('snoop')} >
                เลื่อน
              </IonButton>
            </IonCol>
            <IonCol>
              <IonButton expand="block"  className="action-btn btn-red"
              onClick={() => handleOpenCheckInOut('cancel')} >
                ยกเลิกงาน
              </IonButton>
            </IonCol>
            <IonCol>
              <IonButton expand="block"  className="action-btn btn-green"
              onClick={() => handleOpenCheckInOut('out')} >
                จบการปฏิบัติงาน
              </IonButton>
            </IonCol>
          </IonRow>
        </IonToolbar>
      </IonFooter>

      <IonModal key={checkTitle} isOpen={showCheckIn} onDidPresent={handleModalDidPresent} className="custom-modal">
  <IonHeader className="ion-no-border">
    <IonToolbar color="primary">
      <IonTitle style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
        {checkTitle}
      </IonTitle>
      <IonButtons slot="end">
        <IonButton onClick={handleCloseMap}>ปิด</IonButton>
      </IonButtons>
    </IonToolbar>
  </IonHeader>

  <IonContent className="ion-padding gray-bg">
   
    <div style={{ textAlign: 'center', marginBottom: '20px', marginTop: '10px' }}>
      <IonText className="profile-name">
        <h1 style={{ fontSize: '3rem', margin: '0', fontWeight: 'bold' }}>{time}</h1>
        <p style={{ fontSize: '1.1rem', opacity: '0.7', marginTop: '5px' }}>
          {new Date().toLocaleDateString('th-TH', { 
            day: 'numeric', month: 'long', year: 'numeric' 
          })}
        </p>
      </IonText>
    </div>

   
    <div style={{ 
      borderRadius: '20px', 
      overflow: 'hidden', 
      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
      border: '2px solid white',
      height: '300px'
    }}>
      <MapContainer 
        ref={mapRef} 
        apiKey={mapKey} 
        onAddressFetched={handleAddressFromMap} 
        onLatitudeFetched={handleLatitude}
        onLongitudeFetched={handleLongitude}
      />
    </div>

    
    <div style={{ 
      marginTop: '20px', 
      padding: '15px', 
      backgroundColor: '#f8f9fa', 
      borderRadius: '15px',
      borderLeft: '5px solid var(--ion-color-primary)'
    }}>
      <IonLabel color="medium" style={{ fontSize: '0.9rem' }}>ตำแหน่งปัจจุบันของคุณ:</IonLabel>
      <div style={{ marginTop: '5px' }}>
    {(isLoadAddress) ? (
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <IonSpinner name="crescent" color="primary" />
        <IonText className="profile-name">
          <small>{sprintText}</small>
        </IonText>
      </div>
    ) : (
      <IonText className="profile-name">
        <p style={{ margin: '0', fontWeight: 500, lineHeight: '1.4' }}>
          📍 {myAddress}
        </p>
      </IonText>
    )}
  </div>
    </div>
    <IonAlert
        isOpen={showFailMsg}
        onDidDismiss={() => setShowFailMsg(false)}
        message="ทำรายการไม่สำเร็จโปรดลองอีกครั้ง"
        buttons={['ตกลง']}
      ></IonAlert>
    <IonAlert
  isOpen={showConfirmAlert}
  onDidDismiss={() => setShowConfirmAlert(false)}
  header={'ยืนยัน'+checkBtnText}
  message={`คุณต้องการบันทึกเวลา ${checkTitle} ใช่หรือไม่?`}
  buttons={[
    {
      text: 'ยกเลิก',
      role: 'cancel',
      cssClass: 'secondary',
      handler: () => {
        console.log('User cancelled');
      }
    },
    {
      text: 'ยืนยัน',
      handler: () => {
        handleFinalConfirm(); 
      }
    }
  ]}
/>
   
    <div style={{ marginTop: '30px' }}>
      <IonButton 
        expand="block" 
        shape="round" 
        size="large"
        onClick={handleCheckInClick}
        disabled={isLoadAddress}
        style={{ height: '60px', fontWeight: 'bold', fontSize: '1.1rem' }}
      >
        <span style={{ marginRight: '10px' }}>📍</span> {checkBtnText}
      </IonButton>
    </div>
  </IonContent>
</IonModal>

    </IonPage>

 );
};

export default Con;
